var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sale" }, [
    _c("h2", { staticClass: "normal" }, [_vm._v("审核信息")]),
    _vm._v(" "),
    _vm.queryType !== "入驻审核" &&
    _vm.queryType !== "中介审核" &&
    _vm.queryType !== "头像审核"
      ? _c("div", { staticClass: "userApllyList list" }, [
          _c(
            "div",
            [
              _c("div", { staticClass: "userAplly item" }, [_vm._v("用户")]),
              _vm._v(" "),
              _vm._l(_vm.userApplyList, function(apply, index) {
                return _c(
                  "div",
                  {
                    key: apply.id,
                    staticClass: "userAplly item",
                    on: {
                      click: function($event) {
                        _vm.toCheck((_vm.clickIndex = index))
                      }
                    }
                  },
                  [_vm._v("\n        " + _vm._s(index + 1) + "\n      ")]
                )
              })
            ],
            2
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.queryType === "聊天举报"
      ? _c(
          "div",
          [
            _c(
              "el-select",
              {
                staticStyle: { margin: "20px 0", width: "200px" },
                attrs: { placeholder: "全部" },
                model: {
                  value: _vm.jubao,
                  callback: function($$v) {
                    _vm.jubao = $$v
                  },
                  expression: "jubao"
                }
              },
              _vm._l(["全部", "举报用户", "举报销售"], function(way) {
                return _c("el-option", {
                  key: way,
                  attrs: { label: way, value: way }
                })
              }),
              1
            ),
            _vm._v(" "),
            _c(
              "el-button",
              { attrs: { type: "primary" }, on: { click: _vm.changeWay } },
              [_vm._v("筛选")]
            )
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.queryType === "APP反馈"
      ? _c("div", [
          _vm.feedback
            ? _c("div", [
                _c("div", [
                  _vm._v("反馈人昵称：" + _vm._s(this.item.nickname))
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v("\n        反馈人头像："),
                  _c("br"),
                  _c("img", {
                    attrs: { src: _vm.item.avatar, mode: "scaleToFill" }
                  })
                ]),
                _vm._v(" "),
                _c("div", [_vm._v("反馈信息： " + _vm._s(this.item.words))]),
                _vm._v(" "),
                _c("div", [
                  _vm._v("\n        反馈图片："),
                  _c("br"),
                  _c("img", {
                    staticClass: "feedbackImage",
                    attrs: { src: _vm.item.images }
                  })
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c("el-input", {
                      staticStyle: { width: "200px" },
                      model: {
                        value: _vm.reply_words,
                        callback: function($$v) {
                          _vm.reply_words = $$v
                        },
                        expression: "reply_words"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.setfeedback("拒绝")
                          }
                        }
                      },
                      [_vm._v("拒绝")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.setfeedback("通过")
                          }
                        }
                      },
                      [_vm._v("同意")]
                    )
                  ],
                  1
                )
              ])
            : _vm._e()
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.queryType === "APP进群审核"
      ? _c("div", [
          _vm.currentCheck.check_details
            ? _c("div", [
                _vm.currentCheck.user
                  ? _c("div", { staticClass: "normal" }, [
                      _vm._v(
                        "\n        申请人：" +
                          _vm._s(_vm.currentCheck.user.nickname) +
                          "\n      "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentCheck.name
                  ? _c("div", { staticClass: "normal" }, [
                      _vm._v(
                        "\n        群名：" +
                          _vm._s(_vm.currentCheck.name) +
                          "\n      "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentCheck.check_details.academy
                  ? _c("div", { staticClass: "normal" }, [
                      _vm._v(
                        "\n        院校：" +
                          _vm._s(_vm.currentCheck.check_details.academy) +
                          "\n      "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentCheck.check_details.major
                  ? _c("div", { staticClass: "normal" }, [
                      _vm._v(
                        "\n        专业：" +
                          _vm._s(_vm.currentCheck.check_details.major) +
                          "\n      "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentCheck.check_details.grade
                  ? _c("div", { staticClass: "normal" }, [
                      _vm._v(
                        "\n        入学年份：" +
                          _vm._s(_vm.currentCheck.check_details.grade) +
                          "\n      "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentCheck.check_details.id_card
                  ? _c("div", { staticClass: "normal" }, [
                      _c("div", [_vm._v("校园卡")]),
                      _vm._v(" "),
                      _c("img", {
                        attrs: {
                          src: _vm.currentCheck.check_details.id_card,
                          preview: "0",
                          "preview-text": "校园卡",
                          alt: "加载失败"
                        }
                      })
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentCheck.check_details.Building
                  ? _c("div", { staticClass: "normal" }, [
                      _vm._v(
                        "\n        楼号：" +
                          _vm._s(_vm.currentCheck.check_details.Building) +
                          "\n      "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentCheck.check_details.unit
                  ? _c("div", { staticClass: "normal" }, [
                      _vm._v(
                        "\n        单元：" +
                          _vm._s(_vm.currentCheck.check_details.unit) +
                          "\n      "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentCheck.check_details.roomNum
                  ? _c("div", { staticClass: "normal" }, [
                      _vm._v(
                        "\n        房号：" +
                          _vm._s(_vm.currentCheck.check_details.roomNum) +
                          "\n      "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentCheck.check_details.apply_img
                  ? _c("div", { staticClass: "normal" }, [
                      _c("div", [_vm._v("房产证")]),
                      _vm._v(" "),
                      _c("img", {
                        attrs: {
                          src: _vm.currentCheck.check_details.apply_img,
                          preview: "0",
                          "preview-text": "房产证",
                          alt: "加载失败"
                        }
                      })
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "normal" }, [
                  _c(
                    "button",
                    {
                      on: {
                        click: function($event) {
                          return _vm.dealGroupApply("PASS")
                        }
                      }
                    },
                    [_vm._v("同意")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      on: {
                        click: function($event) {
                          return _vm.dealGroupApply("REFUSE")
                        }
                      }
                    },
                    [_vm._v("拒绝")]
                  )
                ])
              ])
            : _vm._e()
        ])
      : _vm.queryType === "APP建群审核"
      ? _c("div", [
          _vm.currentCheck.check_details
            ? _c("div", [
                _vm.currentCheck.user
                  ? _c("div", { staticClass: "normal" }, [
                      _vm._v(
                        "\n        申请人：" +
                          _vm._s(_vm.currentCheck.user.nickname) +
                          "\n      "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentCheck.check_details.type
                  ? _c("div", { staticClass: "normal" }, [
                      _vm._v(
                        "\n        群类别：" +
                          _vm._s(_vm.currentCheck.check_details.type) +
                          "\n      "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentCheck.check_details.name
                  ? _c("div", { staticClass: "normal" }, [
                      _vm._v(
                        "\n        新建群名：" +
                          _vm._s(_vm.currentCheck.check_details.name) +
                          "\n      "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentCheck.check_details.tip
                  ? _c("div", { staticClass: "normal" }, [
                      _vm._v(
                        "\n        小群标签：" +
                          _vm._s(_vm.currentCheck.check_details.tip) +
                          "\n      "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentCheck.check_details.chat_id
                  ? _c("div", { staticClass: "normal" }, [
                      _vm._v(
                        "\n        绑定的大群名：" +
                          _vm._s(_vm.currentCheck.bigName) +
                          "\n      "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", [
                  _vm._v("\n        提示\n        "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.refuse_reason,
                        expression: "refuse_reason"
                      }
                    ],
                    attrs: { type: "text" },
                    domProps: { value: _vm.refuse_reason },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.refuse_reason = $event.target.value
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "normal" }, [
                  _c(
                    "button",
                    {
                      on: {
                        click: function($event) {
                          return _vm.dealCreateApply("PASS")
                        }
                      }
                    },
                    [_vm._v("通过")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      on: {
                        click: function($event) {
                          return _vm.dealCreateApply("REFUSE")
                        }
                      }
                    },
                    [_vm._v("拒绝")]
                  )
                ])
              ])
            : _vm._e()
        ])
      : _vm.queryType === "APP举报审核"
      ? _c("div", [
          _c("div", [
            _vm.currentCheck.report_name
              ? _c("div", { staticClass: "normal" }, [
                  _vm._v(
                    "\n        举报人：" +
                      _vm._s(_vm.currentCheck.report_name) +
                      "\n      "
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.currentCheck.nickname
              ? _c("div", { staticClass: "normal" }, [
                  _vm._v(
                    "\n        被举报人：" +
                      _vm._s(_vm.currentCheck.nickname) +
                      "\n      "
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.currentCheck.talk
              ? _c("div", { staticClass: "normal" }, [
                  _vm._v(
                    "\n        被举报消息：" +
                      _vm._s(_vm.currentCheck.talk.content) +
                      "\n      "
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.currentCheck.name
              ? _c("div", { staticClass: "normal" }, [
                  _vm._v(
                    "\n        群名：" +
                      _vm._s(_vm.currentCheck.name) +
                      "\n      "
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.currentCheck.chat_id
              ? _c("div", [
                  _c("div", { staticClass: "normal" }, [
                    _vm._v("\n          对被举报者：\n          "),
                    _c(
                      "button",
                      {
                        on: {
                          click: function($event) {
                            return _vm.unAppclock(
                              "拉黑",
                              _vm.currentCheck.to_user,
                              _vm.currentCheck.nickname
                            )
                          }
                        }
                      },
                      [_vm._v("\n            拉黑\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        on: {
                          click: function($event) {
                            return _vm.unAppclock(
                              "解禁",
                              _vm.currentCheck.to_user,
                              _vm.currentCheck.nickname
                            )
                          }
                        }
                      },
                      [_vm._v("\n            解禁\n          ")]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "normal" }, [
                    _vm._v("\n          对举报者：\n          "),
                    _c(
                      "button",
                      {
                        on: {
                          click: function($event) {
                            return _vm.unAppclock(
                              "拉黑",
                              _vm.currentCheck.user_id,
                              _vm.currentCheck.report_name
                            )
                          }
                        }
                      },
                      [_vm._v("\n            拉黑\n          ")]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "normal" }, [
                    _vm._v("\n          对举报记录：\n          "),
                    _c(
                      "button",
                      {
                        on: {
                          click: function($event) {
                            return _vm.shenhe(_vm.currentCheck.id)
                          }
                        }
                      },
                      [_vm._v("标为已审核")]
                    )
                  ])
                ])
              : _vm._e()
          ])
        ])
      : _vm.queryType === "APP申诉"
      ? _c("div", [
          _c("div", [
            _vm.currentCheck.nickname
              ? _c("div", { staticClass: "normal" }, [
                  _vm._v(
                    "\n        申诉人：" +
                      _vm._s(_vm.currentCheck.nickname) +
                      "\n      "
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.currentCheck.name
              ? _c("div", { staticClass: "normal" }, [
                  _vm._v(
                    "\n        群名：" +
                      _vm._s(_vm.currentCheck.name) +
                      "\n      "
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.currentCheck.chat_id
              ? _c("div", [
                  _c("div", { staticClass: "normal" }, [
                    _vm._v("\n          对申诉人：\n          "),
                    _c(
                      "button",
                      {
                        on: {
                          click: function($event) {
                            return _vm.unAppclock(
                              "解禁",
                              _vm.currentCheck.user_id,
                              _vm.currentCheck.nickname
                            )
                          }
                        }
                      },
                      [_vm._v("\n            解禁\n          ")]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "normal" }, [
                    _vm._v("\n          对举报记录：\n          "),
                    _c(
                      "button",
                      {
                        on: {
                          click: function($event) {
                            return _vm.shenhe(_vm.currentCheck.id)
                          }
                        }
                      },
                      [_vm._v("标为已审核")]
                    )
                  ])
                ])
              : _vm._e()
          ])
        ])
      : _vm.queryType === "群聊申诉"
      ? _c("div", [
          _c("div", [
            _vm.currentCheck.user_name
              ? _c("div", { staticClass: "normal" }, [
                  _vm._v(
                    "\n        申诉人昵称：" +
                      _vm._s(_vm.currentCheck.user_name) +
                      "\n      "
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.currentCheck.head_url
              ? _c("div", { staticClass: "normal" }, [
                  _c("img", {
                    attrs: { src: _vm.currentCheck.head_url, alt: "" }
                  })
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.currentCheck.user_name
              ? _c("div", { staticClass: "normal" }, [
                  _vm._v(
                    "\n        申诉人身份：" +
                      _vm._s(_vm.currentCheck.user_type || "普通用户") +
                      "\n      "
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.currentCheck.user_name
              ? _c("div", { staticClass: "normal" }, [
                  _vm._v(
                    "\n        申诉人状态：" +
                      _vm._s(_vm.currentCheck.user_status || "正常") +
                      "\n      "
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.currentCheck.name
              ? _c("div", { staticClass: "normal" }, [
                  _vm._v(
                    "\n        群名：" +
                      _vm._s(_vm.currentCheck.name) +
                      "\n      "
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.currentCheck.rlist
              ? _c(
                  "div",
                  { staticClass: "normal" },
                  [
                    _vm._v("\n        拦截消息\n        "),
                    _vm._l(_vm.currentCheck.rlist, function(item, index) {
                      return _c("div", { key: index }, [
                        item.talk_id.includes("aliyuncs")
                          ? _c("img", {
                              attrs: { src: item.talk_id, preview: "1" }
                            })
                          : _c("span", [_vm._v(_vm._s(item.talk_id))]),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(item.create_time))])
                      ])
                    })
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.currentCheck.rlist
              ? _c("div", [
                  _c("div", { staticClass: "normal" }, [
                    _vm._v("\n          对申诉人：\n          "),
                    _c(
                      "button",
                      {
                        on: {
                          click: function($event) {
                            return _vm.unclock(
                              "解禁",
                              _vm.currentCheck.user_id,
                              _vm.currentCheck.user_name,
                              _vm.currentCheck.id
                            )
                          }
                        }
                      },
                      [_vm._v("\n            解禁\n          ")]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "normal" }, [
                    _vm._v("\n          对举报记录：\n          "),
                    _c(
                      "button",
                      {
                        on: {
                          click: function($event) {
                            return _vm.shenhe(_vm.currentCheck.id)
                          }
                        }
                      },
                      [_vm._v("标为已审核")]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "normal" }, [
                    _vm._v("\n          对举报记录：\n          "),
                    _c(
                      "button",
                      {
                        on: {
                          click: function($event) {
                            return _vm.shenhe(_vm.currentCheck.id, "驳回")
                          }
                        }
                      },
                      [_vm._v("不让再申诉")]
                    )
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.currentCheck.ulist
              ? _c(
                  "div",
                  { staticClass: "normal" },
                  [
                    _vm._v("\n        最近消息\n        "),
                    _vm._l(_vm.currentCheck.ulist, function(item, index) {
                      return _c("div", { key: index }, [
                        item.content.includes("aliyuncs")
                          ? _c("img", {
                              attrs: { src: item.content, preview: "1" }
                            })
                          : _c("span", [_vm._v(_vm._s(item.content))]),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(item.create_time))])
                      ])
                    })
                  ],
                  2
                )
              : _vm._e()
          ])
        ])
      : _vm.queryType === "房源审核"
      ? _c("div", [
          _vm.currentCheck.check_details
            ? _c("div", [
                _vm.currentCheck.user_name
                  ? _c("div", { staticClass: "normal" }, [
                      _vm._v(
                        "\n        经纪人：" +
                          _vm._s(_vm.currentCheck.user_name) +
                          "\n      "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentCheck.check_details.name
                  ? _c("div", { staticClass: "normal" }, [
                      _vm._v(
                        "\n        房源：" +
                          _vm._s(_vm.currentCheck.check_details.name) +
                          "\n      "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentCheck.check_details.number
                  ? _c("div", { staticClass: "normal" }, [
                      _vm._v(
                        "\n        房源编号：" +
                          _vm._s(_vm.currentCheck.check_details.number) +
                          "\n      "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentCheck.check_details.hang_price
                  ? _c("div", { staticClass: "normal" }, [
                      _vm._v(
                        "\n        总价：" +
                          _vm._s(_vm.currentCheck.check_details.hang_price) +
                          "\n      "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentCheck.check_details.purpose
                  ? _c("div", { staticClass: "normal" }, [
                      _vm._v(
                        "\n        类别：" +
                          _vm._s(_vm.currentCheck.check_details.purpose) +
                          "\n      "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentCheck.check_details.layout
                  ? _c("div", { staticClass: "normal" }, [
                      _vm._v(
                        "\n        户型：" +
                          _vm._s(_vm.currentCheck.check_details.layout) +
                          "\n      "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentCheck.check_details.square
                  ? _c("div", { staticClass: "normal" }, [
                      _vm._v(
                        "\n        面积：" +
                          _vm._s(_vm.currentCheck.check_details.square) +
                          "\n      "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentCheck.check_details.trim
                  ? _c("div", { staticClass: "normal" }, [
                      _vm._v(
                        "\n        装修：" +
                          _vm._s(_vm.currentCheck.check_details.trim) +
                          "\n      "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentCheck.check_details.floor
                  ? _c("div", { staticClass: "normal" }, [
                      _vm._v(
                        "\n        楼层：" +
                          _vm._s(_vm.currentCheck.check_details.floor) +
                          "\n      "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", [
                  _vm._v("\n        提示\n        "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.refuse_reason,
                        expression: "refuse_reason"
                      }
                    ],
                    attrs: { type: "text" },
                    domProps: { value: _vm.refuse_reason },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.refuse_reason = $event.target.value
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "normal" }, [
                  _c(
                    "button",
                    {
                      on: {
                        click: function($event) {
                          return _vm.addHang()
                        }
                      }
                    },
                    [_vm._v("通过")]
                  ),
                  _vm._v(" "),
                  _c("button", { on: { click: _vm.refuse } }, [_vm._v("拒绝")])
                ])
              ])
            : _vm._e()
        ])
      : _vm.queryType === "专家入驻"
      ? _c("div", [
          _vm.currentCheck.check_details
            ? _c("div", [
                _vm.currentCheck.check_details.user_name
                  ? _c("div", { staticClass: "normal" }, [
                      _vm._v(
                        "\n        姓名：" +
                          _vm._s(_vm.currentCheck.check_details.user_name) +
                          "\n      "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentCheck.check_details.phone
                  ? _c("div", { staticClass: "normal" }, [
                      _vm._v(
                        "\n        电话：" +
                          _vm._s(_vm.currentCheck.check_details.phone) +
                          "\n      "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentCheck.check_details.Sub_QR
                  ? _c("div", { staticClass: "normal" }, [
                      _c("div", [_vm._v("公众号二维码")]),
                      _vm._v(" "),
                      _c("img", {
                        attrs: {
                          src: _vm.currentCheck.check_details.Sub_QR,
                          preview: "0",
                          "preview-text": "公众号二维码",
                          alt: "加载失败"
                        }
                      })
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentCheck.check_details.Sub_name
                  ? _c("div", { staticClass: "normal" }, [
                      _vm._v(
                        "\n        公众号名：" +
                          _vm._s(_vm.currentCheck.check_details.Sub_name) +
                          "\n      "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentCheck.check_details.Tiktok_QR
                  ? _c("div", { staticClass: "normal" }, [
                      _c("div", [_vm._v("视频号或抖音二维码")]),
                      _vm._v(" "),
                      _c("img", {
                        attrs: {
                          src: _vm.currentCheck.check_details.Tiktok_QR,
                          preview: "0",
                          "preview-text": "视频号或抖音二维码",
                          alt: "加载失败"
                        }
                      })
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentCheck.check_details.Tiktok_Num
                  ? _c("div", { staticClass: "normal" }, [
                      _vm._v(
                        "\n        视频号或抖音名：" +
                          _vm._s(_vm.currentCheck.check_details.Tiktok_Num) +
                          "\n      "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentCheck.check_details.Group_QR
                  ? _c("div", { staticClass: "normal" }, [
                      _c("div", [_vm._v("购房微信群二维码")]),
                      _vm._v(" "),
                      _c("img", {
                        attrs: {
                          src: _vm.currentCheck.check_details.Group_QR,
                          preview: "0",
                          "preview-text": "购房微信群二维码",
                          alt: "加载失败"
                        }
                      })
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentCheck.check_details.Group_Name
                  ? _c("div", { staticClass: "normal" }, [
                      _vm._v(
                        "\n        购房微信群名：" +
                          _vm._s(_vm.currentCheck.check_details.Group_Name) +
                          "\n      "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentCheck.check_details.describe
                  ? _c("div", { staticClass: "normal" }, [
                      _vm._v(
                        "\n        描述：" +
                          _vm._s(_vm.currentCheck.check_details.describe) +
                          "\n      "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentCheck.check_details.field
                  ? _c("div", { staticClass: "normal" }, [
                      _vm._v(
                        "\n        擅长：" +
                          _vm._s(_vm.currentCheck.check_details.field) +
                          "\n      "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentCheck.check_details.district
                  ? _c("div", { staticClass: "normal" }, [
                      _vm._v(
                        "\n        区域：" +
                          _vm._s(_vm.currentCheck.check_details.district) +
                          "\n      "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentCheck.check_details.idCard
                  ? _c("div", { staticClass: "normal" }, [
                      _c("div", [_vm._v("身份证正面")]),
                      _vm._v(" "),
                      _c("img", {
                        attrs: {
                          src: _vm.currentCheck.check_details.idCard,
                          preview: "0",
                          "preview-text": "身份证正面",
                          alt: "加载失败"
                        }
                      })
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentCheck.check_details.idCard2
                  ? _c("div", { staticClass: "normal" }, [
                      _c("div", [_vm._v("身份证反面")]),
                      _vm._v(" "),
                      _c("img", {
                        attrs: {
                          src: _vm.currentCheck.check_details.idCard2,
                          preview: "0",
                          "preview-text": "身份证反面",
                          alt: "加载失败"
                        }
                      })
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", [
                  _vm._v("\n        提示\n        "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.refuse_reason,
                        expression: "refuse_reason"
                      }
                    ],
                    attrs: { type: "text" },
                    domProps: { value: _vm.refuse_reason },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.refuse_reason = $event.target.value
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "normal" }, [
                  _c(
                    "button",
                    {
                      on: {
                        click: function($event) {
                          return _vm.expert()
                        }
                      }
                    },
                    [_vm._v("通过")]
                  ),
                  _vm._v(" "),
                  _c("button", { on: { click: _vm.refuse } }, [_vm._v("拒绝")])
                ])
              ])
            : _vm._e()
        ])
      : _vm.queryType === "业主群审核"
      ? _c("div", [
          _vm.currentCheck.check_details
            ? _c("div", [
                _vm.currentCheck.chat_name
                  ? _c("div", { staticClass: "normal" }, [
                      _vm._v(
                        "\n        业主群：" +
                          _vm._s(_vm.currentCheck.chat_name) +
                          "\n      "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentCheck.user_name
                  ? _c("div", { staticClass: "normal" }, [
                      _vm._v(
                        "\n        姓名：" +
                          _vm._s(_vm.currentCheck.user_name) +
                          "\n      "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentCheck.user_type
                  ? _c("div", { staticClass: "normal" }, [
                      _vm._v(
                        "\n        身份：" +
                          _vm._s(_vm.currentCheck.user_type) +
                          "\n      "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentCheck.check_details.Building
                  ? _c("div", { staticClass: "normal" }, [
                      _vm._v(
                        "\n        楼栋：" +
                          _vm._s(_vm.currentCheck.check_details.Building) +
                          "\n      "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentCheck.check_details.unit
                  ? _c("div", { staticClass: "normal" }, [
                      _vm._v(
                        "\n        单元：" +
                          _vm._s(_vm.currentCheck.check_details.unit) +
                          "\n      "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentCheck.check_details.roomNum
                  ? _c("div", { staticClass: "normal" }, [
                      _vm._v(
                        "\n        房间号：" +
                          _vm._s(_vm.currentCheck.check_details.roomNum) +
                          "\n      "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentCheck.check_details.apply_img
                  ? _c(
                      "div",
                      { staticClass: "normal" },
                      [
                        _c("div", [_vm._v("合同")]),
                        _vm._v(" "),
                        _vm._l(
                          _vm.currentCheck.check_details.apply_img,
                          function(img, index) {
                            return _c(
                              "div",
                              { key: index },
                              [
                                _c("el-image", {
                                  attrs: {
                                    src: img,
                                    alt: "加载失败",
                                    "preview-src-list": [img],
                                    fit: "contain"
                                  }
                                })
                              ],
                              1
                            )
                          }
                        )
                      ],
                      2
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", [
                  _vm._v("\n        提示\n        "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.refuse_reason,
                        expression: "refuse_reason"
                      }
                    ],
                    attrs: { type: "text" },
                    domProps: { value: _vm.refuse_reason },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.refuse_reason = $event.target.value
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "normal" }, [
                  _c(
                    "button",
                    {
                      on: {
                        click: function($event) {
                          return _vm.dealApply("PASS")
                        }
                      }
                    },
                    [_vm._v("通过")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      on: {
                        click: function($event) {
                          return _vm.dealApply("REFUSE")
                        }
                      }
                    },
                    [_vm._v("拒绝")]
                  )
                ])
              ])
            : _vm._e()
        ])
      : _vm.queryType === "举报审核" || _vm.queryType === "聊天举报"
      ? _c("div", [
          _vm.currentCheck &&
          (_vm.currentCheck.report_id || _vm.currentCheck.chat_id)
            ? _c("div", [
                _vm.currentCheck.create_time
                  ? _c("div", { staticClass: "normal" }, [
                      _vm._v(
                        "\n        时间：" +
                          _vm._s(_vm.currentCheck.create_time) +
                          "\n      "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentCheck.user_name
                  ? _c("div", { staticClass: "normal" }, [
                      _vm._v(
                        "\n        举报人：" +
                          _vm._s(_vm.currentCheck.user_name) +
                          "(" +
                          _vm._s("身份：" + _vm.currentCheck.user_type) +
                          ")\n      "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentCheck.report_name
                  ? _c("div", { staticClass: "normal" }, [
                      _vm._v(
                        "\n        被举报人：" +
                          _vm._s(_vm.currentCheck.report_name) +
                          "(" +
                          _vm._s("身份：" + _vm.currentCheck.report_type) +
                          ")\n      "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "normal" }, [
                  _vm._v(
                    "被举报人状态：" + _vm._s(_vm.currentCheck.report_status)
                  )
                ]),
                _vm._v(" "),
                _vm.currentCheck.hang_name
                  ? _c("div", { staticClass: "normal" }, [
                      _vm._v(
                        "\n        调价房源：" +
                          _vm._s(_vm.currentCheck.hang_name) +
                          "\n      "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentCheck.after
                  ? _c("div", { staticClass: "normal" }, [
                      _vm._v(
                        "\n        调价价格：" +
                          _vm._s(_vm.currentCheck.after) +
                          "\n      "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentCheck.chat_name
                  ? _c("div", { staticClass: "normal" }, [
                      _vm._v(
                        "\n        群聊房间：" +
                          _vm._s(_vm.currentCheck.chat_name) +
                          "\n      "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentCheck.words
                  ? _c("div", { staticClass: "normal" }, [
                      _vm._v(
                        "\n        举报" +
                          _vm._s(_vm.currentCheck.chat_id ? "消息" : "理由") +
                          "：" +
                          _vm._s(_vm.currentCheck.words) +
                          "\n      "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentCheck.putImg
                  ? _c("div", { staticClass: "normal" }, [
                      _c("div", [_vm._v("图片")]),
                      _vm._v(" "),
                      _c("img", {
                        attrs: {
                          src: _vm.currentCheck.putImg,
                          preview: "0",
                          "preview-text": "图片",
                          alt: "加载失败"
                        }
                      })
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentCheck.chat_id
                  ? _c("div", [
                      _c("div", { staticClass: "normal" }, [
                        _vm._v("\n          对被举报者：\n          "),
                        _c(
                          "button",
                          {
                            on: {
                              click: function($event) {
                                return _vm.punishUser("禁言", _vm.currentCheck)
                              }
                            }
                          },
                          [_vm._v("禁言")]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            on: {
                              click: function($event) {
                                return _vm.punishUser(
                                  "软隐藏",
                                  _vm.currentCheck
                                )
                              }
                            }
                          },
                          [_vm._v("软隐藏")]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            on: {
                              click: function($event) {
                                return _vm.unclock(
                                  "拉黑",
                                  _vm.currentCheck.to_user,
                                  _vm.currentCheck.report_name
                                )
                              }
                            }
                          },
                          [_vm._v("\n            拉黑\n          ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            on: {
                              click: function($event) {
                                return _vm.unclock(
                                  "解禁",
                                  _vm.currentCheck.to_user,
                                  _vm.currentCheck.report_name
                                )
                              }
                            }
                          },
                          [_vm._v("\n            解禁\n          ")]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "normal" }, [
                        _vm._v("\n          对举报者：\n          "),
                        _c(
                          "button",
                          {
                            on: {
                              click: function($event) {
                                return _vm.unclock(
                                  "拉黑",
                                  _vm.currentCheck.user_id,
                                  _vm.currentCheck.user_name
                                )
                              }
                            }
                          },
                          [_vm._v("\n            拉黑\n          ")]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "normal" }, [
                        _vm._v("\n          对举报记录：\n          "),
                        _c(
                          "button",
                          {
                            on: {
                              click: function($event) {
                                return _vm.shenhe(_vm.currentCheck.id)
                              }
                            }
                          },
                          [_vm._v("标为已审核")]
                        )
                      ])
                    ])
                  : _vm._e()
              ])
            : _vm._e()
        ])
      : _vm.queryType === "拿证审核"
      ? _c("div", [
          _vm.currentCheck.check_details
            ? _c("div", [
                _vm.currentCheck.user
                  ? _c("div", { staticClass: "normal" }, [
                      _vm._v(
                        "\n        顾问：" +
                          _vm._s(_vm.currentCheck.user.user_name) +
                          "\n      "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentCheck.real_estate_name
                  ? _c("div", { staticClass: "normal" }, [
                      _vm._v(
                        "\n        楼盘：" +
                          _vm._s(_vm.currentCheck.real_estate_name) +
                          "\n      "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentCheck.check_details.date
                  ? _c("div", { staticClass: "normal" }, [
                      _vm._v(
                        "\n        拿证：" +
                          _vm._s(_vm.currentCheck.check_details.date.advance) +
                          "\n      "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentCheck.check_details.piece
                  ? _c(
                      "div",
                      {
                        staticClass: "normal",
                        staticStyle: {
                          display: "flex",
                          "justify-content": "center"
                        }
                      },
                      [
                        _c("div", [_vm._v("价格：")]),
                        _vm._v(" "),
                        _vm._l(_vm.currentCheck.check_details.piece, function(
                          p,
                          index
                        ) {
                          return _c("div", { key: index }, [
                            _vm._v(
                              "\n          " +
                                _vm._s(p.type) +
                                _vm._s(p.price) +
                                " \n        "
                            )
                          ])
                        })
                      ],
                      2
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "normal" }, [
                  _vm._v(
                    "\n        楼栋：" +
                      _vm._s(_vm.currentCheck.check_details.info.building) +
                      "\n      "
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "normal" }, [
                  _vm._v(
                    "\n        面积：" +
                      _vm._s(_vm.currentCheck.check_details.info.square) +
                      "\n      "
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "normal" }, [
                  _vm._v(
                    "\n        装修：" +
                      _vm._s(_vm.currentCheck.check_details.info.trim) +
                      "\n      "
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "normal" }, [
                  _vm._v(
                    "\n        套数：" +
                      _vm._s(_vm.currentCheck.check_details.rate.house_total) +
                      "\n      "
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v("\n        提示\n        "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.refuse_reason,
                        expression: "refuse_reason"
                      }
                    ],
                    attrs: { type: "text" },
                    domProps: { value: _vm.refuse_reason },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.refuse_reason = $event.target.value
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "normal" }, [
                  _c(
                    "button",
                    {
                      on: {
                        click: function($event) {
                          return _vm.dealNZ("PASS")
                        }
                      }
                    },
                    [_vm._v("通过")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      on: {
                        click: function($event) {
                          return _vm.dealNZ("REFUSE")
                        }
                      }
                    },
                    [_vm._v("拒绝")]
                  )
                ])
              ])
            : _vm._e()
        ])
      : _vm.queryType === "销售大群审核"
      ? _c("div", [
          _vm.currentCheck.user
            ? _c("div", [
                _c("div", { staticClass: "normal" }, [
                  _vm._v("申请人：" + _vm._s(_vm.currentCheck.user.user_name))
                ]),
                _vm._v(" "),
                _vm.currentCheck.type
                  ? _c("div", { staticClass: "normal" }, [
                      _vm._v(
                        "\n        群类别：" +
                          _vm._s(_vm.currentCheck.type) +
                          "\n      "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentCheck.real_estate_name
                  ? _c("div", { staticClass: "normal" }, [
                      _vm._v(
                        "\n        绑定楼盘：" +
                          _vm._s(_vm.currentCheck.real_estate_name) +
                          "\n      "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", [
                  _vm._v("\n        提示\n        "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.refuse_reason,
                        expression: "refuse_reason"
                      }
                    ],
                    attrs: { type: "text" },
                    domProps: { value: _vm.refuse_reason },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.refuse_reason = $event.target.value
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "normal" }, [
                  _c(
                    "button",
                    {
                      on: {
                        click: function($event) {
                          return _vm.dealxsApply("PASS")
                        }
                      }
                    },
                    [_vm._v("通过")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      on: {
                        click: function($event) {
                          return _vm.dealxsApply("REFUSE")
                        }
                      }
                    },
                    [_vm._v("拒绝")]
                  )
                ])
              ])
            : _vm._e()
        ])
      : _c(
          "div",
          [
            _vm.startCopy
              ? _c(
                  "button",
                  {
                    on: {
                      click: function() {
                        _vm.startCopy = !_vm.startCopy
                      }
                    }
                  },
                  [_vm._v("\n      开始复制\n    ")]
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.startCopy
              ? _c(
                  "button",
                  {
                    on: {
                      click: function() {
                        _vm.startCopy = !_vm.startCopy
                      }
                    }
                  },
                  [_vm._v("\n      取消复制\n    ")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.queryType == "入驻审核"
              ? _c(
                  "div",
                  [
                    _c(
                      "el-radio-group",
                      {
                        on: { change: _vm.switchStatus },
                        model: {
                          value: _vm.checkRadio,
                          callback: function($$v) {
                            _vm.checkRadio = $$v
                          },
                          expression: "checkRadio"
                        }
                      },
                      [
                        _c("el-radio", { attrs: { label: 0 } }, [
                          _vm._v("待审核")
                        ]),
                        _vm._v(" "),
                        _c("el-radio", { attrs: { label: 1 } }, [
                          _vm._v("已拒绝")
                        ]),
                        _vm._v(" "),
                        _c("el-radio", { attrs: { label: 2 } }, [
                          _vm._v("已通过")
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "el-table",
              {
                key: _vm.tableKey,
                attrs: {
                  fit: "",
                  data: _vm.userApplyList,
                  "cell-style": _vm.setStyle,
                  height: _vm.dataHeight + "px"
                }
              },
              [
                _vm.startCopy
                  ? _c("el-table-column", {
                      attrs: {
                        sortable: "",
                        type: "index",
                        label: "序号",
                        prop: ""
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.startCopy
                  ? _c("el-table-column", {
                      attrs: {
                        sortable: "",
                        label: "申请时间",
                        prop: "create_time"
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.startCopy && _vm.checkRadio == 1
                  ? _c("el-table-column", {
                      attrs: { label: "拒绝时间", prop: "update_time" }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.startCopy && _vm.checkRadio == 2
                  ? _c("el-table-column", {
                      attrs: { label: "通过时间", prop: "update_time" }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.startCopy
                  ? _c("el-table-column", {
                      attrs: { label: "身份证", prop: "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(ref) {
                              var row = ref.row
                              return [
                                row.check_details.idCard
                                  ? _c(
                                      "div",
                                      [
                                        _c("el-image", {
                                          attrs: {
                                            src: row.check_details.idCard,
                                            alt: "",
                                            "preview-src-list": [
                                              row.check_details.idCard
                                            ],
                                            fit: "contain"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _c("div", [_vm._v("暂无身份证图片")])
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        3360413235
                      )
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.startCopy
                  ? _c("el-table-column", {
                      attrs: { label: "名片或者工号牌", prop: "create_time" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(ref) {
                              var row = ref.row
                              return [
                                row.check_details.card
                                  ? _c(
                                      "div",
                                      [
                                        _c("el-image", {
                                          attrs: {
                                            src: row.check_details.card,
                                            alt: "",
                                            "preview-src-list": [
                                              row.check_details.card
                                            ],
                                            fit: "contain"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _c("div", [_vm._v("名片或者工号牌")])
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        190734965
                      )
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.startCopy
                  ? _c("el-table-column", {
                      attrs: { label: "头像", prop: "create_time" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(ref) {
                              var row = ref.row
                              return [
                                row.check_details.avatar
                                  ? _c(
                                      "div",
                                      [
                                        _c("el-image", {
                                          attrs: {
                                            src: row.check_details.avatar.replace(
                                              "_mini.jpg",
                                              ""
                                            ),
                                            alt: "",
                                            "preview-src-list": [
                                              row.check_details.avatar.replace(
                                                "_mini.jpg",
                                                ""
                                              )
                                            ],
                                            fit: "contain"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : row.check_details.head_url
                                  ? _c(
                                      "div",
                                      [
                                        _c("el-image", {
                                          attrs: {
                                            src: row.check_details.head_url.replace(
                                              "_mini.jpg",
                                              ""
                                            ),
                                            alt: "",
                                            "preview-src-list": [
                                              row.check_details.head_url.replace(
                                                "_mini.jpg",
                                                ""
                                              )
                                            ],
                                            fit: "contain"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : row.head_url
                                  ? _c(
                                      "div",
                                      [
                                        _c("el-image", {
                                          attrs: {
                                            src: row.head_url,
                                            alt: "",
                                            "preview-src-list": [row.head_url],
                                            fit: "contain"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _c("div", [_vm._v("暂无头像")])
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        763587227
                      )
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.startCopy
                  ? _c("el-table-column", {
                      attrs: { label: "电话", prop: "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(ref) {
                              var row = ref.row
                              return [
                                _c("div", [
                                  _vm._v(_vm._s(row.check_details.phone))
                                ])
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        4205681146
                      )
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.startCopy
                  ? _c("el-table-column", {
                      attrs: { label: "微信号", prop: "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(ref) {
                              var row = ref.row
                              return [
                                _c(
                                  "div",
                                  {
                                    attrs: {
                                      oncopy: function() {
                                        return false
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(row.check_details.weChat_num))]
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        1799526324
                      )
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.startCopy
                  ? _c("el-table-column", {
                      attrs: { label: "二维码", prop: "create_time" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(ref) {
                              var row = ref.row
                              return [
                                row.check_details.weChat_QR
                                  ? _c(
                                      "div",
                                      [
                                        _c("el-image", {
                                          attrs: {
                                            src: row.check_details.weChat_QR,
                                            alt: "",
                                            "preview-src-list": [
                                              row.check_details.weChat_QR
                                            ],
                                            fit: "contain"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _c("div", [_vm._v("暂无二维码")])
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        3285405485
                      )
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.startCopy
                  ? _c("el-table-column", {
                      attrs: { label: "口号" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(ref) {
                              var row = ref.row
                              return [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      row.check_details.brief || "暂无口号"
                                    )
                                  )
                                ])
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        993927197
                      )
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.startCopy && _vm.checkRadio == 0
                  ? _c("el-table-column", {
                      attrs: { label: "顾问状态" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(ref) {
                              var row = ref.row
                              return [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(row.is_new ? "新顾问" : "老顾问")
                                  )
                                ])
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        1943104137
                      )
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.startCopy && (_vm.checkRadio == 1 || _vm.checkRadio == 2)
                  ? _c("el-table-column", {
                      attrs: { label: "审核人", prop: "check_name" }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.startCopy
                  ? _c("el-table-column", {
                      attrs: { label: "提示", prop: "create_time" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(ref) {
                              var row = ref.row
                              return [
                                _c("div", [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.refuse_reason,
                                        expression: "refuse_reason"
                                      }
                                    ],
                                    staticStyle: { width: "100px" },
                                    attrs: { type: "text" },
                                    domProps: { value: _vm.refuse_reason },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.refuse_reason = $event.target.value
                                      }
                                    }
                                  })
                                ])
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        3916914511
                      )
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.startCopy
                  ? _c("el-table-column", {
                      attrs: {
                        width: _vm.startCopy ? "110px" : "300px",
                        label: "绑定楼盘"
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(ref) {
                              var row = ref.row
                              return [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: row.check_details.real_estates,
                                      expression:
                                        "row.check_details.real_estates"
                                    }
                                  ],
                                  staticStyle: { width: "80px" },
                                  attrs: { type: "text" },
                                  domProps: {
                                    value: row.check_details.real_estates
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        row.check_details,
                                        "real_estates",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        1231836302
                      )
                    })
                  : _vm._e(),
                _vm._v(" "),
                !_vm.startCopy
                  ? _c("el-table-column", {
                      attrs: {
                        width: _vm.startCopy ? "110px" : "300px",
                        label: "绑定楼盘"
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(ref) {
                              var row = ref.row
                              return [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(row.check_details.real_estates) +
                                    "\n        "
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        1261715662
                      )
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.startCopy
                  ? _c("el-table-column", {
                      attrs: {
                        width: _vm.startCopy ? "110px" : "300px",
                        label: "姓名",
                        prop: "user_name"
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(ref) {
                              var row = ref.row
                              return [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: row.check_details.user_name,
                                      expression: "row.check_details.user_name"
                                    }
                                  ],
                                  staticStyle: { width: "80px" },
                                  attrs: { type: "text" },
                                  domProps: {
                                    value: row.check_details.user_name
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        row.check_details,
                                        "user_name",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        3961728814
                      )
                    })
                  : _vm._e(),
                _vm._v(" "),
                !_vm.startCopy
                  ? _c("el-table-column", {
                      attrs: {
                        width: _vm.startCopy ? "110px" : "300px",
                        label: "姓名",
                        prop: "user_name"
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(ref) {
                              var row = ref.row
                              return [
                                _c("div", [
                                  _vm._v(_vm._s(row.check_details.user_name))
                                ])
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        3426629071
                      )
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.startCopy && _vm.checkRadio !== 1 && _vm.checkRadio !== 2
                  ? _c("el-table-column", {
                      attrs: {
                        label: "操作",
                        prop: "create_time",
                        "min-width": "200px"
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(ref) {
                              var row = ref.row
                              var $index = ref.$index
                              return [
                                _c(
                                  "el-button",
                                  {
                                    on: {
                                      click: function($event) {
                                        return _vm.pass("user", $index)
                                      }
                                    }
                                  },
                                  [_vm._v("通过")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    on: {
                                      click: function($event) {
                                        return _vm.refuse($index)
                                      }
                                    }
                                  },
                                  [_vm._v("拒绝")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    on: {
                                      click: function($event) {
                                        return _vm.ignore($index)
                                      }
                                    }
                                  },
                                  [_vm._v("忽略")]
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        252351894
                      )
                    })
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c("el-pagination", {
              attrs: {
                "current-page": _vm.currentPage,
                "page-size": _vm.pageSize,
                layout: "total, prev, pager, next, jumper",
                total: _vm.total
              },
              on: { "current-change": _vm.handleCurrentChange }
            })
          ],
          1
        )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-086acd39", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-086acd39","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/operateTeam/newHouse/consultantReview/sale.vue
// module id = null
// module chunks = 